export var PhotoCaptureDownloadArtifactsCategoryNames;
(function (PhotoCaptureDownloadArtifactsCategoryNames) {
    PhotoCaptureDownloadArtifactsCategoryNames["VEHICLE_INFORMATION"] = "Vehicle Information";
    PhotoCaptureDownloadArtifactsCategoryNames["THREE_CORNERS"] = "Three Corners";
    PhotoCaptureDownloadArtifactsCategoryNames["FOUR_CORNERS"] = "Four Corners";
    PhotoCaptureDownloadArtifactsCategoryNames["WIDE_SHOT"] = "Wide Shot";
    PhotoCaptureDownloadArtifactsCategoryNames["VEHICLE_DAMAGE"] = "Vehicle Damage";
    PhotoCaptureDownloadArtifactsCategoryNames["REQUEST_ADDITIONAL"] = "Request Additional";
})(PhotoCaptureDownloadArtifactsCategoryNames || (PhotoCaptureDownloadArtifactsCategoryNames = {}));
//# sourceMappingURL=PhotoCaptureDownloadArtifactsCategoryNames.js.map